import axios from 'axios';
import { FETCH_PACKAGES } from '../types';

export const getPackages = () => async dispatch => {
	let packageData = new FormData();
	packageData.append('action', 'packages');
	packageData.append('slug', 'DiscoverMleiha');
	axios.post('https://api.discovershurooq.ae/api/', packageData).then(res => {
		console.log('res', res);
		dispatch({
			type: FETCH_PACKAGES,
			payload: res.data.data,
		});
	});
};
